export interface A360Lookup {
  code: string;
  displayValue: string;
  effectiveDate: string;
  expirationDate: string;
  filters: any;
  orderNo: number;
  disabled?: boolean;
}

interface PlanAvailability {
  available?: boolean;
  message?: string;
}

interface PlanCoverage {
  code: string;
  name: string;
  applicabilityType: string;
  contributionTypeCd: any;
  rateBasisCd: any;
  benefitTypeCd: any;
}

export interface PlanWithCoverages {
  code: string;
  name: string;
  description: string;
  availability: PlanAvailability;
  coverages: PlanCoverage[];
}

export interface CreateQuoteRequestPayload {
  country: string;
  currencyCd: string;
  customer: {
    _uri: string;
  };
  opportunity: {
    _uri: string;
  };
}

export interface RetreivedPlan {
  name: string;
  description: string;
  key: string;
  planCode: string;
  coverages: Coverage[];
  classes: any[];
  isDisabled?: boolean;
  error?: string;
  propGenSupported?: boolean;
}

export interface Coverage {
  name: string;
  code: string;
  key: string;
  applicability: string;
  benefitType: {};
  contributionType: {};
  rateBasis: {};
  classes: any[];
}

export interface QuoteFormDropdownOption {
  label: string;
  value: string;
}

export interface EntityMinMaxConfig {
  [key: string]: {
    message: string;
    min: number;
    max: number;
    increment: number;
  };
}

export interface MinMaxResult {
  result: {
    valueType: string;
    [key: string]: string;
  };
}

export const enum MinMaxResultValueType {
  Decimal = 'Decimal',
  Integer = 'Integer',
  Money = 'Money',
}
